//import styles from "./style.css";
//import "./App.css";
import "./index.css";

//import styled from 'styled-components';
import { Portfolio } from "./Components/Portfolio";
import Home from "./Compo/Homes/Home";
import About from "./Components/About";
import NavbarNew from "./Components/NavbarNew";
import { AiOutlineArrowUp } from "react-icons/ai";
import "./changeui.css";

function App() {
  return (
    <div as="body" className="App disable-selection">
      <NavbarNew />
      <Portfolio />
    </div>
  );
}

export default App;
